module.exports = __webpack_public_path__ + "static/media/Beidou.01d9b164.png";